import React from 'react';
import { Badge, BadgeProps } from '@doveit/bricks';
import {
  invoiceStatusColors, invoiceStatusIcons, invoiceStatusLabels,
} from '../../../labels';
import { InvoiceStatus } from '../../../domain/types';

export interface InvoiceStatusBadgeProps extends React.AriaAttributes {
  status: InvoiceStatus,
  emphasis?: BadgeProps['emphasis'],
  size?: BadgeProps['size'],
  showIcon?: boolean,
}

const InvoiceStatusBadge: React.FC<InvoiceStatusBadgeProps> = ({
  status,
  size,
  emphasis,
  showIcon,
  ...rest
}) => (
  <Badge
    aria-label="Badge stato pagamento"
    {...rest}
    emphasis={emphasis}
    label={invoiceStatusLabels[status]}
    color={invoiceStatusColors[status]}
    icon={showIcon ? invoiceStatusIcons[status] : undefined}
    size={size}
  />
);

export default InvoiceStatusBadge;
